import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { db } from './firebase';
import { doc, getDoc, collection, query, where, onSnapshot, updateDoc, addDoc, getDocs, orderBy, setDoc} from 'firebase/firestore';
import { RockIcon } from './components/RockIcon';
import { PaperIcon } from './components/PaperIcon';
import { ScissorsIcon } from './components/ScissorsIcon';
import Header from './components/Header';
import { auth } from './firebase';
import SuccessModal from './components/SuccessModal';
import EditEventModal from './components/EditEventModal';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from './firebase';
import Confetti from 'react-confetti';



// 카드 컴포넌트 (텍스트 오버레이)
const CardWithText = ({ card, size = 'medium', showText = true }) => {
  const sizeMap = {
    small: { width: '60px', fontSize: '10px', bottom: '4.5%' },
    medium: { width: '100px', fontSize: '12px', bottom: '4.5%' },
    large: { width: '140px', fontSize: '14px', bottom: '4.5%' }
  };

  const style = sizeMap[size];

  return (
    <div style={{ position: 'relative', width: style.width, display: 'inline-block' }}>
      <img 
        src={card.image} 
        alt={card.name}
        style={{
          width: '100%',
          height: 'auto',
          display: 'block'
        }}
      />
      {showText && (
        <div style={{
          position: 'absolute',
          bottom: style.bottom,
          left: 0,
          right: 0,
          textAlign: 'center',
          fontSize: style.fontSize,
          fontWeight: '700',
          color: '#2C3E50',
          pointerEvents: 'none',
          padding: '0 4px'
        }}>
          {card.name}
        </div>
      )}
    </div>
  );
};

function Event() {
  const { t } = useTranslation();
  
  
  const TAROT_CARDS = [
    { id: 0, image: '/tarot/00-fool.svg', name: t('tarot.fool') },
    { id: 1, image: '/tarot/01-magician.svg', name: t('tarot.magician') },
    { id: 2, image: '/tarot/02-high-priestess.svg', name: t('tarot.highPriestess') },
    { id: 3, image: '/tarot/03-empress.svg', name: t('tarot.empress') },
    { id: 4, image: '/tarot/04-emperor.svg', name: t('tarot.emperor') },
    { id: 5, image: '/tarot/05-hierophant.svg', name: t('tarot.hierophant') },
    { id: 6, image: '/tarot/06-lovers.svg', name: t('tarot.lovers') },
    { id: 7, image: '/tarot/07-chariot.svg', name: t('tarot.chariot') },
    { id: 8, image: '/tarot/08-strength.svg', name: t('tarot.strength') },
    { id: 9, image: '/tarot/09-hermit.svg', name: t('tarot.hermit') },
    { id: 10, image: '/tarot/10-wheel-of-fortune.svg', name: t('tarot.wheelOfFortune') },
    { id: 11, image: '/tarot/11-justice.svg', name: t('tarot.justice') },
    { id: 12, image: '/tarot/12-hanged-man.svg', name: t('tarot.hangedMan') },
    { id: 14, image: '/tarot/14-temperance.svg', name: t('tarot.temperance') },
    { id: 17, image: '/tarot/17-star.svg', name: t('tarot.star') },
    { id: 18, image: '/tarot/18-moon.svg', name: t('tarot.moon') },
    { id: 19, image: '/tarot/19-sun.svg', name: t('tarot.sun') },
    { id: 20, image: '/tarot/20-judgement.svg', name: t('tarot.judgement') },
    { id: 21, image: '/tarot/21-world.svg', name: t('tarot.world') }
  ];

  const PETS = [
    { id: 0, type: 'dog', image: '/pets/dog1.svg', name: t('pets.germanShepherd') },
    { id: 1, type: 'dog', image: '/pets/dog2.svg', name: t('pets.poodle') },
    { id: 2, type: 'dog', image: '/pets/dog3.svg', name: t('pets.goldenRetriever') },
    { id: 3, type: 'dog', image: '/pets/dog4.svg', name: t('pets.bulldog') },
    { id: 4, type: 'cat', image: '/pets/cat1.svg', name: t('pets.ragdoll') },
    { id: 5, type: 'cat', image: '/pets/cat2.svg', name: t('pets.siamese') },
    { id: 6, type: 'cat', image: '/pets/cat3.svg', name: t('pets.americanShorthair') }
  ];
  
  const { eventId } = useParams();
  const [eventNotFound, setEventNotFound] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [eventName, setEventName] = useState(t('loading'));
  const [participants, setParticipants] = useState(0);
  const [choice, setChoice] = useState(null);
  const [hasParticipated, setHasParticipated] = useState(false);
  const [isCreator, setIsCreator] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [winners, setWinners] = useState([]);
  const [copied, setCopied] = useState(false);
  const [winnerCount, setWinnerCount] = useState(1);
  const [correctAnswer, setCorrectAnswer] = useState(null);
  const [correctAnswers, setCorrectAnswers] = useState([]);  // 여러 정답 (새로운!)
  const [selectedAnswers, setSelectedAnswers] = useState([]);  // 모달에서 선택 중
  const [participantsList, setParticipantsList] = useState([]);
  const [showAnswerModal, setShowAnswerModal] = useState(false);
  const [description, setDescription] = useState('');
  const [deliveryMethod, setDeliveryMethod] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [gameType, setGameType] = useState('rps');
  const [gameTypeLoaded, setGameTypeLoaded] = useState(false);
  const [contactInfo, setContactInfo] = useState({ 
    email: '', 
    phone: '', 
    address: '' 

});
  const [hasSubmittedContact, setHasSubmittedContact] = useState(false);
  const [myParticipantId, setMyParticipantId] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState({ title: '', message: '', icon: '✅' });
  const [showEditModal, setShowEditModal] = useState(false);
  const [editForm, setEditForm] = useState({
  name: '',
  description: '',
  deliveryMethod: '',
  imageFile: null,
  imagePreview: null
});
  const [loading, setLoading] = useState(false);

  // 기존 useState들 아래에 추가
  const [isFlipped, setIsFlipped] = useState(false);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  const [winnerContacts, setWinnerContacts] = useState({});

  const [countdown, setCountdown] = useState(null);

  

  // 화면 크기가 변할 때 폭죽 크기도 맞추기 위한 useEffect
  useEffect(() => {
    const handleResize = () => {
      setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleImageChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    setEditForm(prev => ({
      ...prev,
      imageFile: file
    }));
    const reader = new FileReader();
    reader.onloadend = () => {
      setEditForm(prev => ({
        ...prev,
        imagePreview: reader.result
      }));
    };
    reader.readAsDataURL(file);
  }
};

useEffect(() => {
    if (isCreator && showResult) {
      const fetchContacts = async () => {
        try {
          const q = query(collection(db, 'winner_contacts'), where('eventId', '==', eventId));
          const snapshot = await getDocs(q);
          const contacts = {};
          snapshot.docs.forEach(doc => {
            contacts[doc.id] = doc.data(); 
          });
          setWinnerContacts(contacts);
        } catch (error) {
          console.error("연락처 정보를 불러오지 못했습니다.", error);
        }
      };
      fetchContacts();
    }
  }, [isCreator, showResult, eventId]);

const saveEventEdit = async () => {
  if (!editForm.name.trim()) {
    alert(t('alerts.enterEventName'));
    return;
  }

  if (!editForm.description.trim()) {
    alert(t('alerts.enterDescription'));
    return;
  }

  setLoading(true);

  try {
    let newImageUrl = imageUrl;

    // 이미지가 변경되었으면 업로드
    if (editForm.imageFile) {
      const imageRef = ref(storage, `events/${Date.now()}_${editForm.imageFile.name}`);
      await uploadBytes(imageRef, editForm.imageFile);
      newImageUrl = await getDownloadURL(imageRef);
    }

    // Firestore 업데이트
    await updateDoc(doc(db, 'events', eventId), {
      name: editForm.name,
      description: editForm.description,
      deliveryMethod: editForm.deliveryMethod,
      imageUrl: newImageUrl
    });

    // 로컬 state 업데이트
    setEventName(editForm.name);
    setDescription(editForm.description);
    setDeliveryMethod(editForm.deliveryMethod);
    setImageUrl(newImageUrl);

    setShowEditModal(false);
    setSuccessMessage({
      title: t('event.editSuccess'),
      message: '',
      icon: '✅'
    });
    setShowSuccessModal(true);
  } catch (error) {
    console.error('수정 실패:', error);
    alert(t('alerts.editFailed'));
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {  
  if (!eventId) {
    return;
  }  
  // ... Firebase 로드
}, [eventId]); // ← eventId가 의존성에 있어야 함!

  // 참여 여부 확인 (로컬 스토리지)
  useEffect(() => {
    const participated = localStorage.getItem(`participated_${eventId}`);
    const savedGameType = localStorage.getItem(`gameType_${eventId}`);
    
    if (participated) {
      setHasParticipated(true);
      setChoice(participated);
      setIsFlipped(true);
    }
    
    if (savedGameType) {
      setGameType(savedGameType);
      setGameTypeLoaded(true); // 로딩 완료!
    }
  }, [eventId]);

  // 크리에이터 여부 확인
  useEffect(() => {
    const myEventIds = localStorage.getItem('myEventIds');
    if (myEventIds) {
      const ids = JSON.parse(myEventIds);
      if (ids.includes(eventId)) {
        setIsCreator(true);
      }
    }
  }, [eventId]);

 
  useEffect(() => {
    if (!eventId) return;

    const eventRef = doc(db, 'events', eventId);

    // getDoc 대신 onSnapshot을 사용하여 실시간으로 데이터 변화를 감지합니다.
    const unsubscribe = onSnapshot(eventRef, async (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        
        // 1. 이벤트 기본 정보 업데이트
        setEventName(data.name);
        setWinnerCount(data.winnerCount || 1);
        setCorrectAnswer(data.correctAnswer);
        setCorrectAnswers(data.correctAnswers || (data.correctAnswer ? [data.correctAnswer] : []));
        setDescription(data.description || '');
        setDeliveryMethod(data.deliveryMethod || '');
        setImageUrl(data.imageUrl || '');
        setGameType(data.gameType || 'rps');
        setGameTypeLoaded(true); // 로딩 완료!
        
        // 2. 크리에이터 확인
        const currentUser = auth.currentUser;
        if (currentUser && data.creatorId === currentUser.uid) {
          setIsCreator(true);
        } else {
          setIsCreator(false);
        }
        
        // 3. 이벤트 종료(결과 발표) 시 로직
        if (data.completed) {
          //setShowResult(true);
          // 🚨 기존에 있던 setShowResult(true); 는 지워주세요! (타이머가 끝나면 켤 겁니다)

          // 🚨 [추가] 카운트다운 시작 (아직 결과 화면이 안 켜졌고, 카운트다운도 안 한 상태일 때)
          if (!showResult && countdown === null) {
            setCountdown(3);
          }
          try {
            const winnersList = [];
            // 당첨자 ID를 기반으로 participants 컬렉션에서 개별 정보를 가져옵니다.
            if (data.winners && Array.isArray(data.winners)) {
              for (const winnerId of data.winners) {
                if (winnerId && typeof winnerId === 'string') {
                  try {
                    const winnerDoc = await getDoc(doc(db, 'participants', winnerId));
                    if (winnerDoc.exists()) {
                      winnersList.push({ id: winnerDoc.id, ...winnerDoc.data() });
                    }
                  } catch (err) {
                    console.error('당첨자 정보 로드 실패:', winnerId, err);
                  }
                }
              }
            }
            else if (data.winner && typeof data.winner === 'string') {
              try {
                const winnerDoc = await getDoc(doc(db, 'participants', data.winner));
                if (winnerDoc.exists()) {
                  winnersList.push({ id: winnerDoc.id, ...winnerDoc.data() });
                }
              } catch (err) {
                console.error('당첨자 정보 로드 실패:', data.winner, err);
              }
            }
            setWinners(winnersList);
          } catch (error) {
            console.error('당첨자 로드 중 에러:', error);
            setWinners([]);
          }
        } else {
          // 크리에이터가 '결과 발표'를 누르기 전 상태 (또는 발표를 취소했을 때)
          setShowResult(false);
        }
      } else {
        setEventNotFound(true);
        setEventName(t('alerts.eventNotFound'));
      }
    }, (error) => {
      console.error('이벤트 정보를 실시간으로 불러오는 중 에러 발생:', error);
    });

    // 컴포넌트 언마운트 시 실시간 리스너 해제 (메모리 누수 방지)
    return () => unsubscribe();
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId]);


  // 실시간 참여자 수
  useEffect(() => {
    const q = query(
      collection(db, 'participants'),
      where('eventId', '==', eventId)
    );
    
    const unsubscribe = onSnapshot(q, (snapshot) => {
      setParticipants(snapshot.size);
    });

    return () => unsubscribe();
  }, [eventId]);

  // 참여자 목록 실시간
  useEffect(() => {
    const q = query(
      collection(db, 'participants'),
      where('eventId', '==', eventId),
      orderBy('timestamp', 'desc')
    );
    
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const list = snapshot.docs.map((doc, index) => ({
        id: doc.id,
        number: snapshot.size - index,
        ...doc.data()
      }));
      setParticipantsList(list);
    });

    return () => unsubscribe();
  }, [eventId]);


  
  // 당첨자 여부 확인
useEffect(() => {
  let participantId = localStorage.getItem(`participantId_${eventId}`);
  
  if (!participantId && hasParticipated && participantsList.length > 0) {
    console.warn('⚠️ 마이그레이션 필요: participantId 없음');
    const myChoice = localStorage.getItem(`participated_${eventId}`);
    const matchingParticipants = participantsList.filter(p => String(p.choice) === String(myChoice));
    
    if (matchingParticipants.length > 0) {
      const myParticipant = matchingParticipants[matchingParticipants.length - 1];
      participantId = myParticipant.id;
      localStorage.setItem(`participantId_${eventId}`, participantId);
      console.log('✅ participantId 복구:', participantId);
    }
  }
  
  if (participantId) {
    setMyParticipantId(participantId);
    
    const winner = winners.find(w => w.id === participantId);
    if (winner?.contactInfo?.submitted) {
      setHasSubmittedContact(true);
    }
  }
}, [eventId, winners, showResult, hasParticipated, participantsList]);




const submitContactInfo = async () => {
    if (!contactInfo.email && !contactInfo.phone && !contactInfo.address) {
      alert(t('alerts.enterContact'));
      return;
    }

    try {
      // 1. 진짜 개인정보는 철통 보안 'winner_contacts' 금고 DB에 저장 (문서 ID를 참여자 ID와 동일하게)
      await setDoc(doc(db, 'winner_contacts', myParticipantId), {
        eventId: eventId,
        email: contactInfo.email,
        phone: contactInfo.phone,
        address: contactInfo.address,
        submittedAt: new Date()
      });
      
      // 2. 누구나 볼 수 있는 일반 참여자 DB에는 '제출 완료' 마크(boolean)만 남김
      await updateDoc(doc(db, 'participants', myParticipantId), {
        contactSubmitted: true 
      });
      
      setHasSubmittedContact(true);
      // 기존 모달 띄우는 로직 등은 유지
      setSuccessMessage({
        title: t('alerts.contactSaved'),
        message: t('alerts.contactSavedMessage'),
        icon: '📮'
      });
      setShowSuccessModal(true);
    } catch (error) {
      console.error('연락처 저장 실패:', error);
      alert(t('alerts.contactSaveFailed'));
    }
  };

const handleChoice = async (selected) => {
  if (isCreator || isSubmitting) {
    alert(t('alerts.creatorCannotParticipate'));
    return;
  }

  try {
    setIsSubmitting(true);
    let isDuplicate = false;

    // 1. 중복 참여 방지 로직 (로그인 유저 vs 비로그인 유저 분리)
    if (auth.currentUser) {
      // 회원: DB에서 이전 참여 기록 검색
      const participantCheck = await getDocs(
        query(
          collection(db, 'participants'),
          where('eventId', '==', eventId),
          where('userId', '==', auth.currentUser.uid)
        )
      );
      if (participantCheck.size > 0) {
        isDuplicate = true;
      }
    } else {
      // 비회원(게스트): 브라우저 로컬 스토리지 기록으로 검사
      const alreadyParticipated = localStorage.getItem(`participated_${eventId}`);
      if (alreadyParticipated) {
        isDuplicate = true;
      }
    }

    // 중복이면 튕겨내기
    if (isDuplicate) {
      alert(t('alerts.alreadyParticipated'));
      setHasParticipated(true);
      return;
    }

    // 2. 참여 처리 (UI 먼저 업데이트)
    setChoice(selected);
    setHasParticipated(true);
    
    // 3. DB에 저장 (회원은 uid, 비회원은 시간값을 이용한 게스트 ID 부여)
    const docRef = await addDoc(collection(db, 'participants'), {
      eventId: eventId,
      choice: selected,
      userId: auth.currentUser ? auth.currentUser.uid : `guest_${Date.now()}`,
      timestamp: new Date()
    });

    // 4. 브라우저에 참여 기록 남기기 (게스트 중복 방지용)
    localStorage.setItem(`participated_${eventId}`, selected);
    localStorage.setItem(`participantId_${eventId}`, docRef.id);
    localStorage.setItem(`gameType_${eventId}`, gameType);
    setMyParticipantId(docRef.id);

    setTimeout(() => {
      setIsFlipped(true);
    }, 100);

  } catch (error) {
    console.error('저장 실패:', error);
    setHasParticipated(false);
    setChoice(null);
    alert(t('alerts.participationFailed')); // 에러가 나면 띄우는 알림
  }
};

const copyLink = () => {
  const url = window.location.href;
  
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(url).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }).catch(err => {
      console.error('복사 실패:', err);
      fallbackCopyTextToClipboard(url);
    });
  } else {
    fallbackCopyTextToClipboard(url);
  }
};

const fallbackCopyTextToClipboard = (text) => {
  const textArea = document.createElement("textarea");
  textArea.value = text;
  textArea.style.position = "fixed";
  textArea.style.top = "-999999px";
  textArea.style.left = "-999999px";
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  
  try {
    const successful = document.execCommand('copy');
    if (successful) {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } else {
      alert(t('alerts.copyFailed') + '\n' + text);
    }
  } catch (err) {
    alert(t('alerts.copyFailed') + '\n' + text);
  }
  
  document.body.removeChild(textArea);
};

  const announceWinner = () => {
    if (participants === 0) {
      alert(t('alerts.noParticipantsAlert'));
      return;
    }
    
    setShowAnswerModal(true);
  };

const handleAnswerSelect = async (answers) => {
  setShowAnswerModal(false);
  setSelectedAnswers([]);  // 선택 초기화
  
  try {
    const q = query(
      collection(db, 'participants'),
      where('eventId', '==', eventId)
    );
    
    const snapshot = await getDocs(q);
    const participantsList = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    // 여러 정답 중 하나라도 맞춘 참여자 필터링 (OR 조건)
    const correctParticipants = participantsList.filter(p => {
      const choice = String(p.choice);
      return answers.some(answer => String(answer) === choice);
    });

    if (correctParticipants.length === 0) {
      // 선택한 정답들 표시
      let choiceNames = [];
      
      if (gameType === 'rps') {
        choiceNames = answers.map(answer => {
          if (answer === 'rock') return `✊ ${t('event.rock')}`;
          if (answer === 'paper') return `✋ ${t('event.paper')}`;
          return `✌️ ${t('event.scissors')}`;
        });
      } else if (gameType === 'tarot') {
        choiceNames = answers.map(answer => {
          const card = TAROT_CARDS.find(c => c.id === parseInt(answer));
          return card ? card.name : '';
        }).filter(Boolean);
      } else if (gameType === 'pets') {
        choiceNames = answers.map(answer => {
          const pet = PETS.find(p => p.id === parseInt(answer));
          return pet ? pet.name : '';
        }).filter(Boolean);
      }
      
      const choiceText = choiceNames.join(', ');
      alert(t('alerts.noChoiceMultiple', { choices: choiceText }));
      return;
    }

    if (correctParticipants.length < winnerCount) {
   if (!window.confirm(
    t('alerts.fewerWinners', { count: correctParticipants.length })
  )) {
    return;
      }
    }

    const shuffled = [...correctParticipants].sort(() => Math.random() - 0.5);
    const selectedWinners = shuffled.slice(0, winnerCount);
    
    setWinners(selectedWinners);
    setShowResult(true);
    setCorrectAnswers(answers);  // 배열로 저장
    setCorrectAnswer(answers[0]);  // 하위 호환 (첫 번째 정답)

    await updateDoc(doc(db, 'events', eventId), {
      winners: selectedWinners.map(w => w.id),
      correctAnswers: answers,  // 배열로 저장
      correctAnswer: answers[0],  // 하위 호환
      completed: true,
      completedAt: new Date()
    });
  } catch (error) {
    console.error('결과 발표 실패:', error);
    alert(t('alerts.announceResultsFailed'));
  }
};

  // 선택지 렌더링 함수
  const renderChoiceItem = (item, size = 'small') => {
    if (gameType === 'rps') {
      return (
        <>
          <span style={{ fontSize: '32px' }}>
            {item === 'rock' && '✊'}
            {item === 'paper' && '✋'}
            {item === 'scissors' && '✌️'}
          </span>
          <span style={{ fontSize: '18px', fontWeight: '600', color: '#2C3E50' }}>
            {item === 'rock' && t('event.rock')}
            {item === 'paper' && t('event.paper')}
            {item === 'scissors' && t('event.scissors')}
          </span>
        </>
      );
    } else if (gameType === 'tarot') {
      const card = TAROT_CARDS.find(c => c.id === parseInt(item));
      return card ? <CardWithText card={card} size={size} /> : <span>{t('event.select')}</span>;
    } else if (gameType === 'pets') {
      const pet = PETS.find(p => p.id === parseInt(item));
      if (!pet) return <span>{t('event.select')}</span>;
      
      const sizeMap = {
        small: { width: '50px', fontSize: '9px', height: '75px', imgHeight: '45px' },
        medium: { width: '80px', fontSize: '11px', height: '115px', imgHeight: '70px' },
        large: { width: '120px', fontSize: '13px', height: '160px', imgHeight: '100px' }
      };
      const style = sizeMap[size];

    

      
      return (
        // 🚨 [여기에 추가] 이벤트가 존재하지 않거나 삭제되었을 때 보여줄 404 방어 화면
    eventNotFound ? (
      <div style={{
        minHeight: '100vh',
        backgroundColor: '#F4F5F7',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Helvetica Neue", Arial, sans-serif'
      }}>
        <div style={{
          backgroundColor: '#FFFFFF',
          padding: '40px',
          borderRadius: '16px',
          border: '4px solid #2C3E50',
          boxShadow: '8px 8px 0px #2C3E50',
          textAlign: 'center',
          maxWidth: '400px',
          width: '100%'
        }}>
          <div style={{ fontSize: '60px', marginBottom: '20px' }}>🔍</div>
          <h2 style={{ fontSize: '22px', fontWeight: '900', color: '#2C3E50', marginBottom: '15px' }}>
            {t('alerts.eventNotFound')}
          </h2>
          <p style={{ fontSize: '14px', color: '#7F8C8D', fontWeight: '600', marginBottom: '30px', lineHeight: '1.5' }}>
            존재하지 않거나 삭제된 이벤트입니다.<br />주소가 올바른지 다시 확인해 주세요.
          </p>
          <button
            onClick={() => window.location.href = '/'}
            style={{
              width: '100%',
              padding: '14px',
              backgroundColor: '#FFD93D',
              color: '#2C3E50',
              border: '3px solid #2C3E50',
              borderRadius: '8px',
              fontWeight: '800',
              fontSize: '16px',
              cursor: 'pointer',
              boxShadow: '3px 3px 0px #2C3E50',
              fontFamily: 'inherit'
            }}
          >
            메인으로 돌아가기
          </button>
        </div>
      </div>
    ) : (
        <div style={{
          background: '#FFFFFF',
          border: '2px solid #2C3E50',
          borderRadius: '8px',
          padding: '2px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: style.width,
          height: style.height,
          justifyContent: 'space-between'
        }}>
          <div style={{
            width: '100%',
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <img 
              src={pet.image} 
              alt={pet.name}
              style={{
                width: '100%',
                height: style.imgHeight,
                objectFit: 'contain',
                display: 'block'
              }}
            />
          </div>
          <span style={{
            fontSize: style.fontSize,
            fontWeight: '700',
            color: '#2C3E50',
            textAlign: 'center',
            lineHeight: '1.1',
            marginTop: '4px'
          }}>
            {pet.name}
          </span>
        </div>
    )
      );
    }
  };

  const isWinner = winners.some(w => w.id === myParticipantId);


  // ⏱️ 카운트다운 타이머 & 당첨자 진동 효과
  useEffect(() => {
    if (countdown === null) return; // 카운트다운 중이 아니면 무시

    if (countdown > 0) {
      // 1초마다 숫자 1씩 감소
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    } else if (countdown === 0) {
      // 0이 되면 드디어 결과 화면 켜기!
      setShowResult(true); 
      
      // 📳 당첨자에게만 짜릿한 진동 효과 주기 (안드로이드 등 지원 기기에서 작동)
      if (isWinner && window.navigator && window.navigator.vibrate) {
        // 200ms 징~, 100ms 쉼, 200ms 징~ (심장 뛰는 느낌의 패턴)
        window.navigator.vibrate([200, 100, 200]); 
      }
    }
  }, [countdown, isWinner]);


  return (
    <div style={{ 
      //minHeight: '100vh',
      background: '#FFFFFF',
      padding: '4px 10px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Helvetica Neue", Arial, sans-serif'
    }}>
      <Header />
      
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '1px 1px' }}>
        

        {/* 링크 공유 */}
        <div style={{
          backgroundColor: '#A3D9FF',
          padding: '5px',
          borderRadius: '12px',
          marginBottom: '6px',
          border: '3px solid #2C3E50',
        }}>
          {/* <p style={{ 
            margin: '0 0 8px 0', 
            fontSize: '15px', 
            color: '#2C3E50',
            fontWeight: '700',
            textTransform: 'uppercase',
            letterSpacing: '1px'
          }}>
            {t('event.shareLink')}
          </p> */}
          <button
            onClick={copyLink}
            style={{
              width: '100%',
              padding: '12px',
              fontSize: '15px',
              backgroundColor: copied ? '#6BCB77' : '#FFFFFF',
              color: '#2C3E50',
              border: '3px solid #2C3E50',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: '700',
              transition: 'all 0.2s',
              fontFamily: 'inherit'
            }}
          >
            {copied ? t('event.copied') : t('event.copyLink')}
          </button>
        </div>

        {/* 크리에이터 버튼 */}
        {isCreator && (
          <div style={{
            backgroundColor: '#FFD93D',
            padding: '20px',
            borderRadius: '12px',
            marginBottom: '6px',
            border: '3px solid #2C3E50',
          }}>
            <p style={{ 
              margin: '0 0 12px 0', 
              fontSize: '15px', 
              color: '#2C3E50',
              fontWeight: '700',
              textTransform: 'uppercase',
              letterSpacing: '1px'
            }}>
              {t('event.creatorOnly')}
            </p>

            <button
              onClick={announceWinner}
              disabled={showResult}
              style={{
                width: '100%',
                padding: '14px',
                fontSize: '15px',
                backgroundColor: showResult ? '#95A5A6' : '#FF6B9D',
                color: '#FFFFFF',
                border: '3px solid #2C3E50',
                borderRadius: '8px',
                cursor: showResult ? 'not-allowed' : 'pointer',
                fontWeight: '700',
                fontFamily: 'inherit',
                transition: 'all 0.2s'
              }}
            >
              {showResult ? t('event.resultAnnounced') : t('event.announceResult')}
            </button>
          </div>
        )}

       {/* 결과 표시 */}
{showResult && winners.length > 0 && (
  <div style={{
    backgroundColor: '#FFFFFF',
    padding: '20px',
    borderRadius: '16px',
    marginBottom: '6px',
    border: '3px solid #2C3E50',
  }}>
    {/* 정답 공개 */}
    <div style={{
      backgroundColor: gameType === 'rps' ? '#6BCB77' : gameType === 'tarot' ? '#A3D9FF' : '#FFD93D',
      padding: '20px',
      borderRadius: '12px',
      marginBottom: '6px',
      border: '3px solid #2C3E50',
      textAlign: 'center'
    }}>
      <div style={{ 
        fontSize: '15px',
        fontWeight: '700',
        color: '#2C3E50',
        marginBottom: '12px',
        textTransform: 'uppercase',
        letterSpacing: '1px'
      }}>
        {t('event.correctAnswer')}
      </div>
      
      {/* 여러 정답 표시 */}
      <div style={{ 
        fontSize: '20px', 
        fontWeight: '700', 
        color: '#2C3E50',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '15px',
        flexWrap: 'wrap'
      }}>
        {gameType === 'rps' ? (
          <>
            {correctAnswers.map((answer, index) => (
              <div key={index} style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                {answer === 'rock' && <>✊ {t('event.rock')}</>}
                {answer === 'paper' && <>✋ {t('event.paper')}</>}
                {answer === 'scissors' && <>✌️ {t('event.scissors')}</>}
              </div>
            ))}
          </>
        ) : gameType === 'tarot' ? (
          <div style={{
            display: 'flex',
            gap: '12px',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            {correctAnswers.map((answer, index) => {
              const card = TAROT_CARDS.find(c => c.id === parseInt(answer));
              return card ? (
                <div key={index}>
                  <CardWithText card={card} size="large" />
                </div>
              ) : null;
            })}
          </div>
        ) : gameType === 'pets' ? (
          <div style={{
            display: 'flex',
            gap: '12px',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            {correctAnswers.map((answer, index) => {
              const pet = PETS.find(p => p.id === parseInt(answer));
              if (!pet) return null;
              
              return (
                <div key={index} style={{
                  background: '#FFFFFF',
                  border: '3px solid #2C3E50',
                  borderRadius: '12px',
                  padding: '12px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  width: '140px',
                  height: '180px',
                  justifyContent: 'space-between'
                }}>
                  <div style={{
                    width: '100%',
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <img 
                      src={pet.image} 
                      alt={pet.name}
                      style={{
                        width: '100%',
                        height: '120px',
                        objectFit: 'contain',
                        display: 'block'
                      }}
                    />
                  </div>
                  <span style={{
                    fontSize: '16px',
                    fontWeight: '700',
                    color: '#2C3E50',
                    textAlign: 'center',
                    marginTop: '6px'
                  }}>
                    {pet.name}
                  </span>
                </div>
              );
            })}
          </div>
        ) : null}
      </div>
    </div>
    
    <h2 style={{ 
      fontSize: '20px', 
      margin: '0 0 20px 0',
      color: '#2C3E50',
      fontWeight: '700',
      textAlign: 'center'
    }}>
      {t('event.winners')} ({winnerCount})
    </h2>

{/* 추첨 과정 상세 설명 */}
<div style={{
  backgroundColor: '#FFF5E6',
  padding: '20px',
  borderRadius: '12px',
  marginBottom: '6px',
  border: '2px solid #2C3E50'
}}>
  <div style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '15px',
    marginBottom: '6px',
    flexWrap: 'wrap'
  }}>
    <div style={{
      backgroundColor: '#A3D9FF',
      padding: '8px 16px',
      borderRadius: '8px',
      border: '2px solid #2C3E50',
      fontSize: '13px',
      fontWeight: '600',
      color: '#2C3E50'
    }}>
      {t('event.step1', { 
  count: (() => {
    const correctCount = participantsList.filter(
      p => String(p.choice) === String(correctAnswer)
    ).length;
    return correctCount;
  })()
})}
    </div>

    <span style={{ fontSize: '20px', color: '#2C3E50', fontWeight: '700' }}>→</span>
    <div style={{
      backgroundColor: '#FFD93D',
      padding: '8px 16px',
      borderRadius: '8px',
      border: '2px solid #2C3E50',
      fontSize: '13px',
      fontWeight: '600',
      color: '#2C3E50'
    }}>
      {t('event.step2', { count: winnerCount })}
    </div>
  </div>
  <p style={{
    margin: '0',
    fontSize: '12px',
    color: '#7F8C8D',
    textAlign: 'center',
    fontWeight: '500',
    lineHeight: '1.5'
  }}>
    {t('event.randomSelectionInfo')}
  </p>
</div>

    
    {winners.map((winner, index) => {
      const participantInfo = participantsList.find(p => p.id === winner.id);
      const participantNumber = participantInfo ? participantInfo.number : '?';
      
      return (
        <div
          key={winner.id}
          style={{
            backgroundColor: '#FFF5E6',
            padding: '20px',
            borderRadius: '12px',
            marginBottom: index < winners.length - 1 ? '12px' : '0',
            border: '3px solid #2C3E50'
          }}
        >
          <div style={{ 
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '15px',
            flexWrap: 'wrap'
          }}>
            <span style={{
              fontSize: '24px',
              fontWeight: '700',
              color: '#2C3E50'
            }}>
              {index === 0 && '🥇'}
              {index === 1 && '🥈'}
              {index === 2 && '🥉'}
              {index > 2 && t('event.ranking', { rank: index + 1 })}
            </span>
            
            <span style={{
              fontSize: '18px',
              fontWeight: '700',
              color: '#FF6B9D',
              backgroundColor: '#FFFFFF',
              padding: '4px 12px',
              borderRadius: '8px',
              border: '2px solid #2C3E50'
            }}>
              #{participantNumber}
            </span>
            
            {renderChoiceItem(winner.choice, 'medium')}
          </div>

         {/* 당첨자 연락처 렌더링 (크리에이터 화면) */}
      {isCreator && winner.contactSubmitted && winnerContacts[winner.id] && (
        <div style={{
          marginTop: '15px', padding: '15px', backgroundColor: '#A3D9FF',
          borderRadius: '8px', border: '2px solid #2C3E50'
        }}>
          <p style={{ margin: '0 0 8px 0', fontSize: '13px', fontWeight: '600', color: '#2C3E50' }}>
            {t('event.step2', { count: winnerCount })}
          </p>
          {winnerContacts[winner.id].email && (
            <p style={{ margin: '5px 0', fontSize: '14px', color: '#2C3E50' }}>📧 {winnerContacts[winner.id].email}</p>
          )}
          {winnerContacts[winner.id].phone && (
            <p style={{ margin: '5px 0', fontSize: '14px', color: '#2C3E50' }}>📱 {winnerContacts[winner.id].phone}</p>
          )}
          {winnerContacts[winner.id].address && (
            <p style={{ margin: '5px 0', fontSize: '14px', color: '#2C3E50' }}>📦 {winnerContacts[winner.id].address}</p>
          )}
        </div>
      )}
      
      {/* 당첨자가 아직 제출 안 했을 때 */}
      {isCreator && !winner.contactSubmitted && (
        <div style={{
          marginTop: '15px', padding: '12px', backgroundColor: '#FFD93D',
          borderRadius: '8px', border: '2px solid #2C3E50', textAlign: 'center'
        }}>
          <p style={{ margin: 0, fontSize: '13px', color: '#2C3E50', fontWeight: '600' }}>
            ⏳{t('event.waitingContact')}
          </p>
        </div>
      )}
        </div>
      );
    })}
  </div>
)}

        {/* 참여자 목록 */}
        <div style={{
          backgroundColor: '#FFFFFF',
          padding: '18px',
          borderRadius: '16px',
          marginBottom: '6px',
          border: '3px solid #2C3E50',
        }}>
          <h3 style={{ 
            margin: '0 0 20px 0',
            fontSize: '15px',
            color: '#2C3E50',
            fontWeight: '700'
          }}>
            {t('event.participantsList', { count: participants })}
          </h3>
          
          <div className="participant-list" style={{
            maxHeight: '250px',
            overflowY: 'auto',
            paddingRight: '2px',
          }}>
            {participantsList.length === 0 ? (
              <p style={{ 
                color: '#7F8C8D', 
                textAlign: 'center', 
                margin: '20px 0',
                fontSize: '14px'
              }}>
                {t('event.noParticipants')}
              </p>
            ) : (
              participantsList.map(participant => (
                <div
                  key={participant.id}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '12px',
                    marginBottom: '6px',
                    backgroundColor: '#FFF5E6',
                    borderRadius: '8px',
                    border: '2px solid #2C3E50',
                    fontSize: '14px'
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{ 
                      fontWeight: '700',
                      color: '#2C3E50',
                      minWidth: '40px'
                    }}>
                      #{participant.number}
                    </span>
                    {showResult ? (
                      renderChoiceItem(participant.choice)
                    ) : (
                      <>
                        <span style={{ fontSize: '20px' }}>❓</span>
                        <span style={{ color: '#7F8C8D', fontStyle: 'italic', fontWeight: '500' }}>
                          {t('event.participated')}
                        </span>
                      </>
                    )}
                  </div>
                  <span style={{ color: '#7F8C8D', fontSize: '12px' }}>
                    {new Date(participant.timestamp?.toDate()).toLocaleTimeString('ko-KR', {
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </span>
                </div>
              ))
            )}
          </div>
        </div>

        

        {/* 상품 정보 */}
        <div style={{
          backgroundColor: '#FFFFFF',
          padding: '10px',
          borderRadius: '16px',
          marginBottom: '10px',
          border: '3px solid #2C3E50',
        }}>
          {imageUrl && (
            <div style={{ 
              marginBottom: '6px',
              textAlign: 'center',
              padding: '10px',
              backgroundColor: '#FFF5E6',
              borderRadius: '12px',
              border: '2px solid #2C3E50'
            }}>
              <img 
                src={imageUrl} 
                alt={eventName}
                style={{
                  maxWidth: '100%',
                  maxHeight: '200px',
                  borderRadius: '8px',
                  objectFit: 'contain'
                }}
              />
            </div>
          )}

{/* 이벤트 제목 + Edit 버튼 */}
<div style={{ 
  display: 'flex', 
  justifyContent: 'space-between', 
  alignItems: 'center',
  marginBottom: '12px'
}}>
  <h1 style={{ 
    fontSize: '20px',
    fontWeight: '700',
    color: '#2C3E50',
    margin: 0,
    flex: 1
  }}>
    {eventName}
  </h1>
  
  {/* Edit 아이콘 (크리에이터만) */}
  {isCreator && (
    <button
      onClick={() => {
        setEditForm({
          name: eventName,
          description: description,
          deliveryMethod: deliveryMethod,
          imageFile: null,
          imagePreview: imageUrl
        });
        setShowEditModal(true);
      }}
      style={{
        backgroundColor: 'transparent',
        border: 'none',
        fontSize: '18px',
        cursor: 'pointer',
        padding: '8px',
        color: '#7F8C8D',
        transition: 'all 0.2s',
        flexShrink: 0
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.color = '#2C3E50';
        e.currentTarget.style.transform = 'scale(1.15)';
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.color = '#7F8C8D';
        e.currentTarget.style.transform = 'scale(1)';
      }}
      title={t('event.editEvent')}
    >
      ✏️
    </button>
  )}
</div>
        
<div style={{
  //marginTop: '4px',
  padding: '16px',
  backgroundColor: 'rgb(254, 247, 202)',
  border: '2px solid #2C3E50',
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginBottom: '6px',
}}>
 {/* <div style={{ fontSize: '26px' }}>🎁</div> */}
  <div>
    <div style={{
      fontSize: '16px',
      fontWeight: '700',
      color: '#2C3E50'
    }}>
      {t('event.winnersToSelect', { count: winnerCount })}
    </div>
    {/* <div style={{
      fontSize: '13px',
      color: '#7F8C8D',
      marginTop: '4px'
    }}>
      {t('event.winnersHint')}
    </div> */}
  </div>
</div>



          {description && (
            <div style={{
              backgroundColor: '#FFF5E6',
              padding: '16px',
              borderRadius: '8px',
              marginBottom: '6px',
              border: '2px solid #2C3E50',
              
            }}>
              <p style={{ 
                margin: '0', 
                fontSize: '15px',
                color: '#2C3E50',
                whiteSpace: 'pre-wrap',
                lineHeight: '1.6',
                wordBreak: 'break-word',  // ← 추가!
                overflowWrap: 'break-word'  
              }}>
                {description}
              </p>
            </div>
          )}

          
          {deliveryMethod && (
            <div style={{
              backgroundColor: '#A3D9FF',
              padding: '16px',
              borderRadius: '8px',
              marginBottom: '6px',
              border: '2px solid #2C3E50'
            }}>
              <p style={{ 
                margin: '0', 
                fontSize: '14px',
                color: '#2C3E50',
                whiteSpace: 'pre-wrap',
                fontWeight: '600',
                wordBreak: 'break-word',  // ← 추가!
                overflowWrap: 'break-word'
              }}>
                📦 {deliveryMethod}
              </p>
            </div>
          )}

          {/* <p style={{ 
            fontSize: '16px', 
            color: '#7F8C8D',
            margin: '20px 10px 10px 10px',
            fontWeight: '700'
          }}>
            {t('participants')}: {participants}{t('event.winnerCount', { count: '' })}
          </p> */}
        </div>

            {/* 참여 완료 메시지 */}
       {/* 🟢 1. 폭죽(Confetti) 효과 (결과 발표 & 내가 당첨자일 때만 터짐) */}
      {showResult && isWinner && (
        <Confetti
          width={windowSize?.width || window.innerWidth}
          height={windowSize?.height || window.innerHeight}
          recycle={false} // 한 번만 화려하게 팡 터지게
          numberOfPieces={800} // 폭죽 800개!
          gravity={0.15}
          style={{ position: 'fixed', top: 0, left: 0, zIndex: 9999 }}
        />
      )}

      {/* 🟢 2. 참여 완료 메시지 & 3D 뒤집기 카드 (대표님이 찾으신 바로 그 부분!) */}
      {hasParticipated && !isCreator && gameTypeLoaded && (
        <div style={{
          backgroundColor: '#6BCB77',
          padding: '40px 20px', // 네오 브루탈리즘답게 시원하게 여백 확보
          borderRadius: '16px',
          margin: '20px 0',
          border: '4px solid #2C3E50',
          boxShadow: '6px 6px 0px #2C3E50', // 강렬한 그림자
          textAlign: 'center'
        }}>
          <h3 style={{ 
            margin: '0 0 30px 0',
            color: '#FFFFFF',
            fontSize: '24px',
            fontWeight: '900'
          }}>
            {t('event.participated')}
          </h3>
          
          {/* 🃏 3D 카드 애니메이션 영역 시작 */}
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div className={`flip-card ${isFlipped ? 'flipped' : ''}`} style={{ width: '150px', height: '200px' }}>
              <div className="flip-card-inner">
                
                {/* 겉면: 물음표 덮개 */}
                <div className="flip-card-front">
                  ❓
                </div>
                
                {/* 뒷면: 실제 카드 (대표님 코드 그대로 이식!) */}
                <div className="flip-card-back" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
                  
                  {gameType === 'rps' ? (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%', border: '3px solid #2C3E50', borderRadius: '12px', padding: '10px', backgroundColor: '#FFFFFF' }}>
                      <span style={{ fontSize: '60px', marginBottom: '10px' }}>
                        {choice === 'rock' && '✊'}
                        {choice === 'paper' && '✋'}
                        {choice === 'scissors' && '✌️'}
                      </span>
                      <span style={{ fontSize: '20px', fontWeight: '800', color: '#2C3E50' }}>
                        {choice === 'rock' && t('event.rock')}
                        {choice === 'paper' && t('event.paper')}
                        {choice === 'scissors' && t('event.scissors')}
                      </span>
                    </div>
                  ) : gameType === 'tarot' ? (
                    <>
                      {(() => {
                        const card = TAROT_CARDS.find(c => c.id === parseInt(choice));
                        return card ? (
                          <div style={{
                            background: '#FFFFFF',
                            border: '3px solid #2C3E50',
                            borderRadius: '12px',
                            padding: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                            height: '100%',
                            boxSizing: 'border-box'
                          }}>
                            <CardWithText card={card} size="large" showText={true} />
                          </div>
                        ) : <span style={{ color: '#2C3E50', fontSize: '20px' }}>{t('event.selectionComplete')}</span>;
                      })()}
                    </>
                  ) : gameType === 'pets' ? (
                    <>
                      {(() => {
                        const pet = PETS.find(p => p.id === parseInt(choice));
                        if (!pet) return <span style={{ color: '#2C3E50', fontSize: '20px' }}>{t('event.selectionComplete')}</span>;
                        
                        return (
                          <div style={{
                            background: '#FFFFFF',
                            border: '3px solid #2C3E50',
                            borderRadius: '12px',
                            padding: '12px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            width: '100%',
                            height: '100%',
                            justifyContent: 'space-between',
                            boxSizing: 'border-box'
                          }}>
                            <div style={{ width: '100%', flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                              <img src={pet.image} alt={pet.name} style={{ width: '100%', height: '110px', objectFit: 'contain', display: 'block' }} />
                            </div>
                            <span style={{ fontSize: '15px', fontWeight: '700', color: '#2C3E50', textAlign: 'center', marginTop: '4px' }}>
                              {pet.name}
                            </span>
                          </div>
                        );
                      })()}
                    </>
                  ) : null}

                </div>
              </div>
            </div>
          </div>
          {/* 🃏 3D 카드 애니메이션 영역 끝 */}

          <p style={{ 
            fontSize: '16px', 
            color: '#FFFFFF',
            margin: '30px 0 0 0',
            fontWeight: '800'
          }}>
            {showResult ? t('event.resultAnnounced2') : t('event.waitResult')}
          </p>
        </div>
      )}
        
        {/* 당첨자 연락처 입력 폼 */}
        {showResult && !isCreator && isWinner && !hasSubmittedContact && (
          <div style={{
            backgroundColor: '#FFD93D',
            padding: '20px',
            borderRadius: '16px',
            margin: '6px 0',
            border: '3px solid #2C3E50',
            //boxShadow: '3px 3px 0px #2C3E50'
          }}>
            <h3 style={{ 
              margin: '0 0 15px 0',
              color: '#2C3E50',
              fontSize: '22px',
              fontWeight: '700',
              textAlign: 'center'
            }}>
              🎉 {t('event.winnerConfirmation')}
            </h3>
            
            <div style={{
              backgroundColor: '#FFF5E6',
              padding: '15px',
              borderRadius: '8px',
              marginBottom: '8px',
              border: '2px solid #2C3E50'
            }}>
              <p style={{
                margin: '0',
                fontSize: '16px',
                color: '#2C3E50',
                fontWeight: '600',
                textAlign: 'center'
              }}>
                {t('event.winnerNumbers', { numbers: winners.map(w => {
                  const p = participantsList.find(pp => pp.id === w.id);
                  return p ? `#${p.number}` : '?';
                }).join(', ') })}
              </p>
            </div>
            
            <p style={{
              margin: '0 0 20px 0',
              fontSize: '14px',
              color: '#2C3E50',
              textAlign: 'center',
              fontWeight: '500'
            }}>
              {t('event.enterContactPrompt')}
            </p>
            
            <div style={{ marginBottom: '15px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                fontSize: '13px',
                fontWeight: '600',
                color: '#2C3E50'
              }}>
                📧 {t('event.email')}
              </label>
              <input
                type="email"
                placeholder={t('event.emailPlaceholder')}
                value={contactInfo.email}
                onChange={(e) => setContactInfo({...contactInfo, email: e.target.value})}
                style={{
                  width: '100%',
                  padding: '12px',
                  fontSize: '15px',
                  border: '2px solid #2C3E50',
                  borderRadius: '8px',
                  boxSizing: 'border-box',
                  fontFamily: 'inherit'
                }}
              />
            </div>
            
            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                fontSize: '13px',
                fontWeight: '600',
                color: '#2C3E50'
              }}>
                📦 {t('event.deliveryAddress')}
              </label>
              <textarea
                placeholder={t('event.addressPlaceholder')}
                value={contactInfo.address}
                onChange={(e) => setContactInfo({...contactInfo, address: e.target.value})}
                style={{
                  width: '100%',
                  padding: '12px',
                  fontSize: '15px',
                  border: '2px solid #2C3E50',
                  borderRadius: '8px',
                  boxSizing: 'border-box',
                  minHeight: '80px',
                  resize: 'vertical',
                  fontFamily: 'inherit'
                }}
              />
            </div>
            
            <button
              onClick={submitContactInfo}
              style={{
                width: '100%',
                padding: '16px',
                fontSize: '16px',
                backgroundColor: '#6BCB77',
                color: '#FFFFFF',
                border: '3px solid #2C3E50',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: '700',
                fontFamily: 'inherit',
                boxShadow: '4px 4px 0px #2C3E50',
                transition: 'all 0.2s'
              }}
            >
              {t('event.submitContact')}
            </button>
            
            <p style={{
              margin: '15px 0 0 0',
              fontSize: '12px',
              color: '#7F8C8D',
              textAlign: 'center',
              fontWeight: '500'
            }}>
              🔒 {t('event.creatorOnly')}
            </p>
          </div>
        )}

        {/* 연락처 제출 완료 */}
        {hasSubmittedContact && showResult && !isCreator && (
          <div style={{
            backgroundColor: '#6BCB77',
            padding: '25px',
            borderRadius: '12px',
            margin: '10px 0',
            border: '3px solid #2C3E50',
            //boxShadow: '4px 4px 0px #2C3E50',
            textAlign: 'center'
          }}>
            <h3 style={{ 
              margin: '0 0 10px 0',
              color: '#FFFFFF',
              fontSize: '20px',
              fontWeight: '700'
            }}>
              ✅ {t('event.contactSubmitted')}
            </h3>
            <p style={{
              margin: 0,
              fontSize: '14px',
              color: '#FFFFFF',
              fontWeight: '600'
            }}>
              {t('event.creatorWillContact')}
            </p>
          </div>
        )}

        {/* 💔 미당첨자 결과 화면 (위로 및 다른 채널 유도) */}
        {showResult && !isCreator && hasParticipated && !isWinner && (
          <div style={{
            backgroundColor: '#95A5A6', // 차분한 네오 브루탈리즘 그레이
            padding: '30px 20px',
            borderRadius: '16px',
            margin: '10px 0',
            border: '4px solid #2C3E50',
            boxShadow: '4px 4px 0px #2C3E50',
            textAlign: 'center'
          }}>
            <h3 style={{ 
              margin: '0 0 15px 0', 
              color: '#FFFFFF', 
              fontSize: '24px', 
              fontWeight: '900' 
            }}>
             {t('event.loserTitle')}
            </h3>
            <p style={{
              margin: '0 0 25px 0',
              fontSize: '15px',
              color: '#FFFFFF',
              fontWeight: '600',
              lineHeight: '1.5'
            }}>
              {t('event.loserMessage').split('\n').map((line, i) => (
                <React.Fragment key={i}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </p>
            
            {/* 유기적인 트래픽을 위한 액션 버튼 */}
            <button
              onClick={() => window.location.href = '/'} // 추후 통합 랜딩 페이지나 다른 앱 링크로 변경 가능
              style={{
                width: '100%',
                padding: '14px',
                backgroundColor: '#FFFFFF',
                color: '#2C3E50',
                border: '3px solid #2C3E50',
                borderRadius: '8px',
                fontWeight: '800',
                fontSize: '16px',
                cursor: 'pointer',
                fontFamily: 'inherit',
                boxShadow: '2px 2px 0px #2C3E50',
                transition: 'transform 0.1s'
              }}
              onMouseDown={(e) => {
                e.currentTarget.style.transform = 'translate(2px, 2px)';
                e.currentTarget.style.boxShadow = '0px 0px 0px #2C3E50';
              }}
              onMouseUp={(e) => {
                e.currentTarget.style.transform = 'translate(0px, 0px)';
                e.currentTarget.style.boxShadow = '2px 2px 0px #2C3E50';
              }}
            >
              {t('event.exploreOtherEvents')}
            </button>
          </div>
        )}

        {/* 게임 버튼 */}
        {!hasParticipated && !isCreator && !gameTypeLoaded && (
          <div style={{ 
            marginTop: '30px',
            textAlign: 'center',
            padding: '40px',
            backgroundColor: '#FFFFFF',
            borderRadius: '12px',
            border: '3px solid #2C3E50'
          }}>
            <p style={{ 
              margin: 0, 
              fontSize: '16px', 
              color: '#7F8C8D',
              fontWeight: '600'
            }}>
              {t('event.loading')}
            </p>
          </div>
        )}

        {/* 게임 버튼 */}
        {!hasParticipated && !isCreator && gameTypeLoaded && (
          <div style={{ marginTop: '10px' }}>
            {gameType === 'rps' ? (
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(3, 1fr)', 
                gap: '8px' 
              }}>
                <button 
                  onClick={() => handleChoice('scissors')}
                  disabled={isSubmitting}
                  style={{
                    padding: '10px 10px',
                    fontSize: '16px',
                    backgroundColor: '#FF6B9D',
                    color: '#FFFFFF',
                    border: '3px solid #2C3E50',
                    borderRadius: '12px',
                    cursor: 'pointer',
                    fontWeight: '700',
                    transition: 'all 0.2s',
                    fontFamily: 'inherit',
                    boxShadow: '1px 1px 0px #2C3E50'
                  }}
                >
                  <div style={{ marginBottom: '8px' }}>
                    <ScissorsIcon size={80} />
                  </div>
                  <div>{t('event.scissors')}</div>
                </button>

                <button 
                  onClick={() => handleChoice('rock')}
                  disabled={isSubmitting}
                  style={{
                    padding: '10px 10px',
                    fontSize: '16px',
                    backgroundColor: '#A3D9FF',
                    color: '#2C3E50',
                    border: '3px solid #2C3E50',
                    borderRadius: '12px',
                    cursor: 'pointer',
                    fontWeight: '700',
                    transition: 'all 0.2s',
                    fontFamily: 'inherit',
                    boxShadow: '1px 1px 0px #2C3E50'
                  }}
                >
                  <div style={{ marginBottom: '8px' }}>
                    <PaperIcon size={80} />
                  </div>
                  <div>{t('event.paper')}</div>
                </button>

                <button 
                  onClick={() => handleChoice('paper')}
                  disabled={isSubmitting}
                  style={{
                    padding: '10px 10px',
                    fontSize: '16px',
                    backgroundColor: '#FFD93D',
                    color: '#2C3E50',
                    border: '3px solid #2C3E50',
                    borderRadius: '12px',
                    cursor: 'pointer',
                    fontWeight: '700',
                    transition: 'all 0.2s',
                    fontFamily: 'inherit',
                    boxShadow: '1px 1px 0px #2C3E50'
                  }}
                >
                  <div style={{ marginBottom: '8px' }}>
                    <RockIcon size={80} />
                  </div>
                  <div>{t('event.paper')}</div>
                </button>
              </div>
              
            ) : gameType === 'tarot' ? (
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(90px, 1fr))',
                gap: '10px',
                maxWidth: '100%'
              }}>
                {TAROT_CARDS.map(card => (
                  <button
                    key={card.id}
                    onClick={() => handleChoice(card.id)}
                    disabled={isSubmitting}
                    style={{
                      background: 'transparent',
                      border: 'none',
                      padding: 0,
                      cursor: 'pointer',
                      fontFamily: 'inherit',
                      transition: 'transform 0.2s',
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'translateY(-4px)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                    }}
                  >
                    <CardWithText card={card} size="medium" />
                  </button>
                ))}
              </div>
            ) : gameType === 'pets' ? (
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(110px, 1fr))',
                gap: '15px',
                maxWidth: '100%'
              }}>
                {PETS.map(pet => (
                  <button
                    key={pet.id}
                    onClick={() => handleChoice(pet.id)}
                    disabled={isSubmitting}
                    style={{
                      background: '#FFFFFF',
                      border: '3px solid #2C3E50',
                      borderRadius: '12px',
                      padding: '12px',
                      cursor: 'pointer',
                      fontFamily: 'inherit',
                      transition: 'all 0.2s',
                      boxShadow: '1px 1px 0px #2C3E50',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      height: '170px',
                      justifyContent: 'space-between'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'translate(-2px, -2px)';
                      e.currentTarget.style.boxShadow = '3px 3px 0px #2C3E50';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'translate(0, 0)';
                      e.currentTarget.style.boxShadow = '2px 2px 0px #2C3E50';
                    }}
                  >
                    <div style={{
                      width: '100%',
                      flex: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <img 
                        src={pet.image} 
                        alt={pet.name}
                        style={{
                          width: '100%',
                          height: '90px',
                          objectFit: 'contain',
                          display: 'block'
                        }}
                      />
                    </div>
                    <span style={{
                      fontSize: '13px',
                      fontWeight: '700',
                      color: '#2C3E50',
                      textAlign: 'center',
                      lineHeight: '1.2',
                      marginTop: '8px'
                    }}>
                      {pet.name}
                    </span>
                  </button>
                ))}
              </div>
            ) : null}
          </div>
        )}

        {/* 정답 선택 모달 */}
     {showAnswerModal && (
  <div style={{
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(44, 62, 80, 0.8)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
    padding: '20px'
  }}>
    <div style={{
      backgroundColor: '#FFFFFF',
      borderRadius: '16px',
      padding: '40px',
      maxWidth: '600px',
      width: '100%',
      maxHeight: '90vh',
      overflowY: 'auto',
      border: '4px solid #2C3E50',
      boxShadow: '8px 8px 0px #2C3E50'
    }}>
      <h2 style={{ 
        fontSize: '24px', 
        marginBottom: '15px',
        textAlign: 'center',
        color: '#2C3E50',
        fontWeight: '700'
      }}>
        {t('event.selectCorrectAnswer')}
      </h2>
      
      {/* 선택 개수 표시 */}
      <p style={{ 
        color: '#6BCB77', 
        marginBottom: '15px',
        textAlign: 'center',
        fontSize: '16px',
        fontWeight: '700'
      }}>
        {selectedAnswers.length}/{winnerCount} {t('event.selected')}
      </p>
      
      <p style={{ 
        color: '#7F8C8D', 
        marginBottom: '30px',
        textAlign: 'center',
        fontSize: '14px',
        fontWeight: '500'
      }}>
        {t('event.selectUpTo', { count: winnerCount })}
      </p>
      
      {gameType === 'rps' ? (
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: '15px',
          marginBottom: '20px'
        }}>
          {['rock', 'paper', 'scissors'].map((choice) => {
            const isSelected = selectedAnswers.includes(choice);
            const icons = { rock: '✊', paper: '✋', scissors: '✌️' };
            const colors = { rock: '#FF6B9D', paper: '#A3D9FF', scissors: '#FFD93D' };
            
            return (
              <button
                key={choice}
                onClick={() => {
                  if (isSelected) {
                    setSelectedAnswers(prev => prev.filter(a => a !== choice));
                  } else if (selectedAnswers.length < winnerCount) {
                    setSelectedAnswers(prev => [...prev, choice]);
                  }
                }}
                style={{
                  padding: '30px 20px',
                  fontSize: '16px',
                  backgroundColor: isSelected ? colors[choice] : '#FFFFFF',
                  color: isSelected ? (choice === 'paper' || choice === 'scissors' ? '#2C3E50' : '#FFFFFF') : '#7F8C8D',
                  border: `3px solid ${isSelected ? '#2C3E50' : '#BDC3C7'}`,
                  borderRadius: '12px',
                  cursor: 'pointer',
                  fontWeight: '700',
                  transition: 'all 0.2s',
                  fontFamily: 'inherit',
                  boxShadow: isSelected ? '4px 4px 0px #2C3E50' : 'none',
                  opacity: (!isSelected && selectedAnswers.length >= winnerCount) ? 0.5 : 1
                }}
              >
                <div style={{ marginBottom: '8px' }}>{icons[choice]}</div>
                <div>{t(`event.${choice}`)}</div>
                {isSelected && <div style={{ marginTop: '8px', fontSize: '20px' }}>✓</div>}
              </button>
            );
          })}
        </div>
      ) : gameType === 'tarot' ? (
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(90px, 1fr))',
          gap: '10px',
          maxWidth: '100%',
          marginBottom: '20px'
        }}>
          {TAROT_CARDS.map(card => {
            const isSelected = selectedAnswers.includes(card.id);
            
            return (
              <button
                key={card.id}
                onClick={() => {
                  if (isSelected) {
                    setSelectedAnswers(prev => prev.filter(a => a !== card.id));
                  } else if (selectedAnswers.length < winnerCount) {
                    setSelectedAnswers(prev => [...prev, card.id]);
                  }
                }}
                style={{
                  background: 'transparent',
                  border: isSelected ? '3px solid #6BCB77' : '3px solid transparent',
                  borderRadius: '8px',
                  padding: '4px',
                  cursor: 'pointer',
                  fontFamily: 'inherit',
                  transition: 'all 0.2s',
                  position: 'relative',
                  opacity: (!isSelected && selectedAnswers.length >= winnerCount) ? 0.5 : 1
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <CardWithText card={card} size="medium" />
                {isSelected && (
                  <div style={{
                    position: 'absolute',
                    top: '8px',
                    right: '8px',
                    backgroundColor: '#6BCB77',
                    color: '#FFFFFF',
                    borderRadius: '50%',
                    width: '24px',
                    height: '24px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '14px',
                    fontWeight: '700',
                    border: '2px solid #2C3E50'
                  }}>
                    ✓
                  </div>
                )}
              </button>
            );
          })}
        </div>
      ) : gameType === 'pets' ? (
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(110px, 1fr))',
          gap: '15px',
          maxWidth: '100%',
          marginBottom: '20px'
        }}>
          {PETS.map(pet => {
            const isSelected = selectedAnswers.includes(pet.id);
            
            return (
              <button
                key={pet.id}
                onClick={() => {
                  if (isSelected) {
                    setSelectedAnswers(prev => prev.filter(a => a !== pet.id));
                  } else if (selectedAnswers.length < winnerCount) {
                    setSelectedAnswers(prev => [...prev, pet.id]);
                  }
                }}
                style={{
                  background: isSelected ? '#E8F5E9' : '#FFFFFF',
                  border: `3px solid ${isSelected ? '#6BCB77' : '#2C3E50'}`,
                  borderRadius: '12px',
                  padding: '12px',
                  cursor: 'pointer',
                  fontFamily: 'inherit',
                  transition: 'all 0.2s',
                  boxShadow: isSelected ? '4px 4px 0px #6BCB77' : '3px 3px 0px #2C3E50',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  height: '170px',
                  justifyContent: 'space-between',
                  position: 'relative',
                  opacity: (!isSelected && selectedAnswers.length >= winnerCount) ? 0.5 : 1
                }}
                onMouseOver={(e) => {
                  if (isSelected || selectedAnswers.length < winnerCount) {
                    e.currentTarget.style.transform = 'translate(-2px, -2px)';
                    e.currentTarget.style.boxShadow = isSelected ? '6px 6px 0px #6BCB77' : '5px 5px 0px #2C3E50';
                  }
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'translate(0, 0)';
                  e.currentTarget.style.boxShadow = isSelected ? '4px 4px 0px #6BCB77' : '3px 3px 0px #2C3E50';
                }}
              >
                <div style={{
                  width: '100%',
                  flex: 1,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <img 
                    src={pet.image} 
                    alt={pet.name}
                    style={{
                      width: '100%',
                      height: '90px',
                      objectFit: 'contain',
                      display: 'block'
                    }}
                  />
                </div>
                <span style={{
                  fontSize: '13px',
                  fontWeight: '700',
                  color: '#2C3E50',
                  textAlign: 'center',
                  lineHeight: '1.2',
                  marginTop: '8px'
                }}>
                  {pet.name}
                </span>
                {isSelected && (
                  <div style={{
                    position: 'absolute',
                    top: '8px',
                    right: '8px',
                    backgroundColor: '#6BCB77',
                    color: '#FFFFFF',
                    borderRadius: '50%',
                    width: '24px',
                    height: '24px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '14px',
                    fontWeight: '700',
                    border: '2px solid #2C3E50'
                  }}>
                    ✓
                  </div>
                )}
              </button>
            );
          })}
        </div>
      ) : null}
      
      {/* 버튼들 */}
      <div style={{ display: 'flex', gap: '12px' }}>
        <button
          onClick={() => {
            setSelectedAnswers([]);
            setShowAnswerModal(false);
          }}
          style={{
            flex: 1,
            padding: '16px',
            backgroundColor: '#FFFFFF',
            color: '#2C3E50',
            border: '3px solid #2C3E50',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: '700',
            fontFamily: 'inherit',
            boxShadow: '2px 2px 0px #2C3E50'
          }}
        >
          {t('logout.cancel')}
        </button>
        
        <button
          onClick={() => {
            if (selectedAnswers.length > 0) {
              handleAnswerSelect(selectedAnswers);
            }
          }}
          disabled={selectedAnswers.length === 0}
          style={{
            flex: 1,
            padding: '16px',
            backgroundColor: selectedAnswers.length === 0 ? '#95A5A6' : '#6BCB77',
            color: '#FFFFFF',
            border: '3px solid #2C3E50',
            borderRadius: '8px',
            cursor: selectedAnswers.length === 0 ? 'not-allowed' : 'pointer',
            fontSize: '16px',
            fontWeight: '700',
            fontFamily: 'inherit',
            boxShadow: selectedAnswers.length === 0 ? 'none' : '2px 2px 0px #2C3E50'
          }}
        >
          {t('event.confirm')}
        </button>
      </div>
    </div>
      
  </div>
)}

        {isCreator && (
          <div style={{ 
            marginTop: '40px', 
            paddingTop: '20px', 
            borderTop: '2px solid #2C3E50',
            textAlign: 'center'
          }}>
            <a 
              href="/"
              style={{
                color: '#2C3E50',
                textDecoration: 'none',
                fontSize: '14px',
                fontWeight: '700'
              }}
            >
              {t('event.backToMyEvents')}
            </a>
          </div>
        )}


      </div>

      {/* ⏳ 수정된 카운트다운 오버레이 */}
      {countdown !== null && countdown > 0 && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
          backgroundColor: 'rgba(44, 62, 80, 0.95)',
          zIndex: 99999, 
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'
        }}>
          <h2 style={{ color: '#FFFFFF', fontSize: '28px', marginBottom: '20px', fontWeight: '800' }}>
            {t('event.announcingResult')}
          </h2>
          <div style={{
            fontSize: '150px', 
            fontWeight: '900', 
            color: '#FFD93D', 
            textShadow: '8px 8px 0px #FF6B9D', 
            lineHeight: '1'
          }}>
            {countdown}
          </div>
        </div>
      )}


      {/* Edit Modal */}
      <EditEventModal
        isOpen={showEditModal}
        onClose={() => setShowEditModal(false)}
        onSave={saveEventEdit}
        editForm={editForm}
        setEditForm={setEditForm}
        handleImageChange={handleImageChange}
        loading={loading}
      />


{/* Success Modal */}
      <SuccessModal
        isOpen={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        title={successMessage.title}
        message={successMessage.message}
        icon={successMessage.icon}
      />
    </div>
  );
}
export default Event;